<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar">

        <i *ngIf="!showAvatar || !user.avatar"
           class="far fa-lg fa-user-circle"></i>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item
            (click)="userProfile()">
        <i class="far mr-2 fa-user-circle"></i>
        <span>Profile</span>
    </button>
    <button mat-menu-item>
        <i class="far mr-2 fa-cog"></i>
        <span>Settings</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <i class="far mr-2 fa-sign-out-alt"></i>
        <span>Sign out</span>
    </button>
</mat-menu>

